export enum DATE_TIME_FORMAT_TYPES {
	DATE = "YYYY-MM-DD",
	DATE_TIME = "YYYY-MM-DD HH:mm",
	TIME = "HH:mm",
	MINUTES_SECONDS = "mm:ss",
	HOURS_MINUTES = "HH:mm",
	HOURS = "h",
	// DATE_WEEKDAY = "ddd DD",
	DATE_WEEKDAY_MONTH = "ddd DD MMM",
}
